//专项练习
export const examinationCentreRoters = [
    {
        path: '/examination-centre',
        name: 'examination-centre',
        component: ()=> import('@/views/examinationCentre/index.vue'),
        meta:{
            title:"专项练习"
        }
    },
    {
        path: '/national-exam-simulation',
        name: 'national-exam-simulation',
        component: ()=> import('@/views/nationalExamSimulation/index.vue'),
        meta:{
            title: "国考模拟"
        }
    },
       {// 国考跳转中间页--仅初级、中级，中间筛选页
           path: '/national-exam-simulation-middle',
           name: 'national-exam-simulationMiddle',
           component: ()=> import('@/views/nationalExamSimulation/middle.vue'),
           meta:{
               title: "国考模拟"
           }
       },
        {
        path: '/national-exam-simulation-list',
        name: 'national-exam-simulation-list',
        component: ()=> import('@/views/nationalExamSimulation/list.vue'),
        meta:{
            title: "国考模拟"
        }
    },
]
